import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '~/app/core/auth/services/authentication.service';
import { LayoutService } from '~/app/core/services/store/layout.service';

export const rootGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const layoutService = inject(LayoutService);

  if (route.queryParams['s']) {
    router.navigate(['/'], { queryParams: route.queryParams });
  } else {
    router.navigate(['/']);
  }

  layoutService.toggleUserSidebar(true);

  const nextUrl = state.url.indexOf('?') >= 0 ? state.url.substring(0, state.url.indexOf('?')) : state.url;

  switch (nextUrl) {
    case '/auth/login':
    case '/auth/domain-login':
    case '/auth/confirm-registration':
      return authService.logoutUserIfNeeded();
    case '/auth/register':
      authService.registrateUser = true;
      return true;
    case '/auth/reset-password':
      authService.resetPasswordUser = true;
      return true;
    default:
      return false;
  }
};
